import { ItineraryStatus, WaypointActionStatusName, WaypointStatusName, ProcedureStatus } from '@caresend/types';
import { hasStatus } from '@caresend/utils';
import { defineComponent, computed, watch } from 'vue';
import __vue_component__ from '../../../../../inputs/SelectComponent.vue.js';
import { itineraryStatusConfig } from './model.js';
import __vue_component__$1 from '../../../../../ui/Skeleton.vue.js';
import __vue_component__$2 from '../../../../../ui/Tooltip/Tooltip.vue.js';

const getItineraryStatusConfig = (status) => itineraryStatusConfig[status];
var script = defineComponent({
    name: 'ItineraryRelatedStatusView',
    components: { SelectComponent: __vue_component__, Skeleton: __vue_component__$1, Tooltip: __vue_component__$2 },
    props: {
        disabledStatuses: {
            type: Array,
            default: () => [],
        },
        status: {
            type: String,
            default: ItineraryStatus.CREATED,
        },
        statusType: {
            type: String,
            default: 'itinerary',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: String,
            default: '',
        },
        /**
         * List of statuses that users are not allowed to change from. i.e Procedure cancelation cannot be reverted.
         */
        restrictChangesFrom: {
            type: Array,
            default: () => [ItineraryStatus.DRAFT],
        },
    },
    setup(props, { emit }) {
        const statusUIConfig = computed(() => getItineraryStatusConfig(props.status));
        watch(() => props.status, () => statusUIConfig.value);
        const statusSource = computed(() => {
            switch (props.statusType) {
                case 'itinerary':
                    return Object.values(ItineraryStatus);
                case 'procedure':
                    return Object.values(ProcedureStatus);
                case 'waypoint':
                    return Object.values(WaypointStatusName);
                case 'waypointAction':
                    return Object.values(WaypointActionStatusName);
            }
        });
        const statusOptions = statusSource.value
            .map((status) => {
            const config = itineraryStatusConfig[status];
            if (config.disabled)
                return config;
            return {
                ...config,
                disabled: props.disabledStatuses.includes(config.status),
            };
        });
        const updateStatus = (status) => emit('updateStatus', status);
        const tooltipLabel = computed(() => {
            if (hasStatus(props.status, ItineraryStatus.DRAFT))
                return 'Commit changes to itinerary';
            if (props.restrictChangesFrom.includes(props.status))
                return 'Cannot revert status';
        });
        return {
            statusOptions,
            statusUIConfig,
            tooltipLabel,
            updateStatus,
        };
    },
});

export { script as default };
